
        Component.define('cookiebar', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el    = $(el);
const $btnOK = $el.find('.btn-ok');

if (getCookie('cookieOptinCore')) {
    $el.hide();
} else {
    TweenLite.from($el, .4, {y: '110%'});
}

$btnOK.on('click', function() {
    let cookie = {
        cookieOptinCore: 1
    };

    let limit_date = keepConnect();

    createCookie(cookie, limit_date);

    TweenLite.to($el, .4, {y: '110%'});
});


function keepConnect() {
    let expire = new Date();
    let limit  = expire.getMonth() + 6;

    if (limit > 11) {
        expire.setMonth(limit - 12);
        expire.setFullYear(expire.getFullYear() + 1);
    } else {
        expire.setMonth(limit);
    }

    return expire;
}

function createCookie(data, limit) {
    for (let item in data) {
        document.cookie = `${item}=${data[item]}; expires=${limit}; path=/`;
    }
}

function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');

    for(var i = 0; i < ca.length; i++) {
        let c = ca[i];

        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }

    return false;
}


        });